import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=9b9606d4&scoped=true&"
var script = {}
import style0 from "./Product.vue?vue&type=style&index=0&id=9b9606d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9606d4",
  null
  
)

export default component.exports